var images_loaded = 0;
var antimoderate_images = document.querySelectorAll('.antimoderate');
var images_interval = [];

for(var i=0; i < antimoderate_images.length; ++i) {
    var img = antimoderate_images[i];
}

function preloadImage(i,n) {
    var img = jQuery('<img class="antimoderate-hd" />').attr('src', i.attr('data-hdsrc'))
        .on('load', function() {
            if (!this.complete || typeof this.naturalWidth == "undefined" || this.naturalWidth == 0) {
                console.log('broken image!');
            } else {
                images_loaded++;
                if (i.hasClass('antimoderate-bg')) {
                    i.css('backgroundImage', 'url('+i.attr('data-hdsrc')+')');
                }
            }
        });
}

(function( $ ) {
    $(function() {
        $(document).ready(function(){
            $('.antimoderate').each(function(i){
                var temp_img = $(this);
                preloadImage(temp_img,i);
            });
        });
    });
})(jQuery);